export default __webpack_public_path__ + "static/media/case-9.e5f0a6c3.png";